export const CHIEF_COMPLAINTS_TOOLTIP_LABEL = 'Chief complaint(s): '
const CHIEF_COMPLAINTS_SEPARATOR = ', '

const readComplaint = (row: unknown): string => {
  if (!row || typeof row !== 'object') return ''
  const { complaint } = row as { complaint?: unknown }
  return typeof complaint === 'string' ? complaint.trim() : ''
}

// The appointment's chief complaints as one line, in payload order; malformed rows are skipped.
export const formatChiefComplaints = (complaints: unknown): string =>
  Array.isArray(complaints)
    ? complaints.map(readComplaint).filter(Boolean).join(CHIEF_COMPLAINTS_SEPARATOR)
    : ''
